<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">{{ $t("cml_location") }}</h4>
                    <button
                       v-if="permision_role.method_create"
                      class="btn btn-primary float-end btn-xs"
                      style="margin-right: 5px"
                      @click.prevent="createData()"
                    >
                      <i class="link-icon" data-feather="plus"></i>
                      {{ $t("createNew") }}
                    </button>
                    
                    <button
                      v-if="permision_role.method_read"
                      class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px"
                      @click.prevent="downloadData()"
                    >
                       <i class="link-icon" data-feather="download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button>
                  </div>
  
                  <div class="card-body">
                    <vue-good-table
                      title="list-billing-cml-master-locations"
                      ref="list-billing-cml-master-locations"
                      :select-options="{enabled: false, selectOnCheckboxOnly: false,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                      mode="remote"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }"
                      :rows="rows"
                      :columns="columns"
                     
                    >
  
                    <!--<div slot="table-actions">
                      {{ $t("no_select_data") }}
                    </div>-->
                    <div slot="selected-row-actions">
                      <button v-if="permision_role.method_delete" class="btn btn-danger btn-xs" style="margin-right:20px;" @click="deleteMass"> <i
                          class="mdi mdi-send-outline"></i> {{ $t("DeleteTxt") }}</button>
  
                      <button class="btn btn-success btn-xs" @click="removeOrderHeaderIds"><i class="mdi mdi-close"></i> {{
                          $t("cancel_order_txt")
                      }} </button>
                    </div>
  
                       <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                               
                              <a
                                href="#"
                                v-if="permision_role.method_read"
                                title="Detail"
                                @click.prevent="detailData(props.index, props.row)"
                              >
                                <i class="mdi mdi-eye" style="font-size:16px"></i>
                                
                              </a>
  
                              <a
                                href="#"
                                v-if="permision_role.method_update"
                                title="Edit"
                                @click.prevent="editData(props.index, props.row)"
                              >
                                <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>
                                
                              </a>
  
                              <a
                                href="#"
                                v-if="permision_role.method_delete"
                                title="Delete"
                                @click.prevent="
                                  deleteData(props.index, props.row)
                                "
                              >
                                <i class="mdi mdi-trash-can-outline" style="font-size:16px"></i> 
                              </a>
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
  
  
          <!--begin::modal-->
  
          <modal name="createBillingCmlMasterLocations" :draggable="false" :scrollable="true" :height="'auto'">
            <div class="modal fade show" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
            <form class="forms-sample" @submit.prevent="submitData" method="POST">
              
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{this.$t("create_customer_txt")}}</h5>
              <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
            </div>
  
            <div class="modal-body">
                
                <div class="mb-3">
                    <label for="warehouseId" class="form-label">{{this.$t("warehouseId_txt")}}:</label>
                    <input type="text" class="form-control" id="warehouseId" :placeholder="$t('warehouseId_txt')" v-model="forms.warehouseId" @input="forms.warehouseId = $event.target.value.toUpperCase()" required/>
                    <div v-if="errors.warehouseId">
                    <div
                        v-for="error in errors.warehouseId"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                    >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                    </div>
                    </div>
                </div>
    
                <div class="mb-3">
                    <label for="locationCategory" class="form-label">{{this.$t("locationCategory")}}:</label>
                    <input type="text" class="form-control" id="locationCategory" :placeholder="$t('locationCategory')" v-model="forms.locationCategory" @input="forms.locationCategory = $event.target.value.toUpperCase()" required/>
                    <div v-if="errors.locationCategory">
                    <div
                        v-for="error in errors.locationCategory"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                    >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                    </div>
                    </div>
                </div>
  
                <div class="mb-3">
                <label for="zona" class="form-label">{{this.$t("zona")}}:</label>
                <input type="text" class="form-control" id="zona" :placeholder="$t('zona')" v-model="forms.zona" @input="forms.zona = $event.target.value.toUpperCase()" required/>
                <div v-if="errors.zona">
                    <div
                    v-for="error in errors.zona"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                    >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                    </div>
                </div>
                </div>
  
            </div>
  
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
              <button type="submit" class="btn btn-primary">{{ this.$t("save_change_txt") }}</button>
            </div>
  
            </form>
                </div>
              </div>
            </div>
          </modal>
  
          <modal name="editBillingCmlMasterLocations" :draggable="false" :scrollable="true" :height="'auto'">
            <div class="modal fade show" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                
            <form class="forms-sample" @submit.prevent="submitEditData" method="POST">
              
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{this.$t("update_bm_code_txt")}}</h5>
              <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
            </div>
  
            <div class="modal-body">
                
                
                <div class="mb-3">
                    <label for="warehouseId" class="form-label">{{this.$t("warehouseId_txt")}}:</label>
                    <input type="text" class="form-control" id="warehouseId" :placeholder="$t('warehouseId_txt')" v-model="forms.warehouseId" @input="forms.warehouseId = $event.target.value.toUpperCase()" required/>
                    <div v-if="errors.warehouseId">
                    <div
                        v-for="error in errors.warehouseId"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                    >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                    </div>
                    </div>
                </div>
    
                <div class="mb-3">
                    <label for="locationCategory" class="form-label">{{this.$t("locationCategory")}}:</label>
                    <input type="text" class="form-control" id="locationCategory" :placeholder="$t('locationCategory')" v-model="forms.locationCategory" @input="forms.locationCategory = $event.target.value.toUpperCase()" required/>
                    <div v-if="errors.locationCategory">
                    <div
                        v-for="error in errors.locationCategory"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                    >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                    </div>
                    </div>
                </div>
  
                <div class="mb-3">
                <label for="zona" class="form-label">{{this.$t("zona")}}:</label>
                <input type="text" class="form-control" id="zona" :placeholder="$t('zona')" v-model="forms.zona" @input="forms.zona = $event.target.value.toUpperCase()" required/>
                <div v-if="errors.zona">
                    <div
                    v-for="error in errors.zona"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                    >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                    </div>
                </div>
                </div>
  
            </div>
  
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
              <button type="submit" class="btn btn-primary">{{ this.$t("save_change_txt") }}</button>
            </div>
  
            </form>
                </div>
              </div>
            </div>
          </modal>
  
  
          <modal name="detailBillingCmlMasterLocations" :draggable="false" :scrollable="true" :height="'auto'">
            <div class="modal fade show" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{this.$t("detail_bm_code_txt")}}</h5>
              <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
            </div>
  
            <div class="modal-body">
                
              
              <div class="mb-3">
                <label for="warehouseId" class="form-label">{{this.$t("warehouseId_txt")}}:</label>
                <input type="text" class="form-control" id="warehouseId" :placeholder="$t('warehouseId_txt')" v-model="forms.warehouseId" disabled/>
                <div v-if="errors.warehouseId">
                  <div
                    v-for="error in errors.warehouseId"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
  
              <div class="mb-3">
                <label for="locationCategory" class="form-label">{{this.$t("locationCategory")}}:</label>
                <input type="text" class="form-control" id="locationCategory" :placeholder="$t('locationCategory')" v-model="forms.locationCategory" disabled/>
                <div v-if="errors.locationCategory">
                  <div
                    v-for="error in errors.locationCategory"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
  
            <div class="mb-3">
              <label for="zona" class="form-label">{{this.$t("zona")}}:</label>
              <input type="text" class="form-control" id="zona" :placeholder="$t('zona')" v-model="forms.zona" disabled/>
              <div v-if="errors.zona">
                <div
                  v-for="error in errors.zona"
                  :key="error"
                  class="alert alert-primary"
                  role="alert"
                >
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
  
    
  
  
          <div class="mb-3">
            <label for="addwho" class="form-label">{{this.$t("create_by_txt")}}:</label>
            <input type="text" class="form-control" id="addwho" :placeholder="$t('create_by_txt')" v-model="forms.addwho" disabled/>
            <div v-if="errors.addwho">
              <div
                v-for="error in errors.addwho"
                :key="error"
                class="alert alert-primary"
                role="alert"
              >
                <i data-feather="alert-circle"></i>
                {{ error }}
              </div>
            </div>
          </div>
  
          <div class="mb-3">
            <label for="editwho" class="form-label">{{this.$t("update_by_txt")}}:</label>
            <input type="text" class="form-control" id="editwho" :placeholder="$t('update_by_txt')" v-model="forms.editwho" disabled/>
            <div v-if="errors.editwho">
              <div
                v-for="error in errors.editwho"
                :key="error"
                class="alert alert-primary"
                role="alert"
              >
                <i data-feather="alert-circle"></i>
                {{ error }}
              </div>
            </div>
          </div>
              
              
          <div class="mb-3">
            <label for="adddate" class="form-label">{{this.$t("create_at_txt")}}:</label>
            <input type="text" class="form-control" id="adddate" :placeholder="$t('create_at_txt')" v-model="forms.adddate" disabled/>
            <div v-if="errors.adddate">
              <div
                v-for="error in errors.adddate"
                :key="error"
                class="alert alert-primary"
                role="alert"
              >
                <i data-feather="alert-circle"></i>
                {{ error }}
              </div>
            </div>
          </div>
              
          <div class="mb-3">
            <label for="editdate" class="form-label">{{this.$t("update_at_txt")}}:</label>
            <input type="text" class="form-control" id="editdate" :placeholder="$t('update_at_txt')" v-model="forms.editdate" disabled/>
            <div v-if="errors.editdate">
              <div
                v-for="error in errors.editdate"
                :key="error"
                class="alert alert-primary"
                role="alert"
              >
                <i data-feather="alert-circle"></i>
                {{ error }}
              </div>
            </div>
          </div>
              
  
            </div>
  
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
            </div>
   
                </div>
              </div>
            </div>
          </modal>
          <!--end::modal-->
  
  
          
        </div>
      </div>
    </div>
</template>
  
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  
  export default {
    name: "BillingCmlMasterLocationsIndex",
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
    },
    data() {
      return {
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        isLoading: false,
        errors: [],
        idLocCategorys:[],
        forms:{idLocCategory:"",warehouseId:"",locationCategory:"",adddate:"",addwho:"",editdate:"",editwho:"",zona:""},
        permision_role:[],
        langs: ["id", "en"],
        detailUser: [],
        detailDivisi: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: "",
            type: "",
          },
          page: 1,
          per_page: 10,
        },
        columns: [
            {
            label: this.$t("action_txt"),
            field: "actions",
            sortable: false,
            thClass: 'text-center',
          },
          {
            label: this.$t("idLocCategory"),
            field: "idLocCategory",
            width: "200px",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("idLocCategory"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("warehouseId_txt"),
            field: "warehouseId",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("warehouseId_txt"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("locationCategory"),
            field: "locationCategory",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("locationCategory"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("zona"),
            field: "zona",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("zona"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
        ],
        rows: [],
      };
    },
    watch: {},
    methods: {
  
        deleteMass() {
            
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataSend"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
                //this.loadingSubmiting();
                this.loading();
                let data = {
                idLocCategorys: this.idLocCategorys
                }
                const baseURI =
                this.$settings.endPointBilling + "dashboard/cml-billing/location-category/delete-mass";
                this.$http
                .post(baseURI, data)
                .then((response) => {
                    //this.loading();
                    this.success(response.data.datas.messages);
                    this.loadItems();
                })
                .catch((error) => {
                    this.loading();
                   
       
       
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

                });
            }else{
                this.isLoading = false;
            }
            });
    
        },
  
  
        success2(msg) {
            let pesan = "";
            msg.forEach((item) => {
            pesan = pesan + "<p>* " + item + "</p>";
            });
    
            this.$swal({
            icon: 'info',
            backdrop: true,
            title: "Information",
            html: pesan,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false
            })
    
    
        },
      
      removeOrderHeaderIds() {
        this.idLocCategorys = [];
        this.$refs['list-billing-cml-master-locations'].unselectAllInternal()
      },
  
      selectionChanged(ev) {
        this.rowsSelection = [];
        this.idLocCategorys   = [];
        this.rowsSelection = ev.selectedRows;
  
        this.rowsSelection.forEach((item) => {
          this.idLocCategorys.push(item.idLocCategory);
  
        });
  
      },
  
  
      submitEditData() {
        this.isLoading = true;
              
        const baseURI  =  this.$settings.endPointBilling + "dashboard/cml-billing/location-category/update/"+this.forms.idLocCategory;
        this.$http.patch(baseURI,this.forms,{ timeout: 60000 }).then((response) => {
            this.loading();
            if(response.data.status === 200) {
            //this.resetForm();
                this.isLoading = false;
                this.errors = [];
                this.removeModals()
                this.loadItems()
                this.success(response.data.datas.messages);
            }else{
                this.isLoading = false;
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
            }
        }).catch(error => {
              this.loading();
              this.isLoading = false;
              
       
       
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

        });
      },
  
      submitData() {
        this.isLoading = true;
              
        const baseURI  =  this.$settings.endPointBilling + "dashboard/cml-billing/location-category/create";
        this.$http.post(baseURI,this.forms,{ timeout: 60000 }).then((response) => {
            this.loading();
            if(response.data.status === 200) {
            //this.resetForm();
                this.isLoading = false;
                this.errors = [];
                this.removeModals()
                this.loadItems()
                this.success('Successfully');
            }else{
                this.isLoading = false;
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
            }
        }).catch(error => {
              this.loading();
              this.isLoading = false;
              
       
       
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

        });
      },
  
      removeModals(){
        
        this.$modal.hide('detailBillingCmlMasterLocations')
        this.$modal.hide('createBillingCmlMasterLocations')
        this.$modal.hide('editBillingCmlMasterLocations')
        this.forms.idLocCategory    = ""
        this.forms.warehouseId       = ""
        this.forms.locationCategory = ""
        this.forms.zona             = ""
        this.forms.adddate          = ""
        this.forms.addwho           = ""
        this.forms.editdate         = ""
        this.forms.editwho          = ""
        this.errors                 = []
  
      },
  
      downloadData() {
        const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/location-category";
        var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
        var file_name = "download_" + CurrentDate + ".xlsx";
  
        //var columnFilters = this.serverParams.columnFilters;
  
  
        return this.$http
          .get(
            baseURI +
              `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&locationCategory=${this.serverParams.columnFilters.locationCategory}&warehouseId=${this.serverParams.columnFilters.warehouseId}&zona=${this.serverParams.columnFilters.zona}&idLocCategory=${this.serverParams.columnFilters.idLocCategory}&download=download`,
            {
              responseType: "blob",
            }
          )
          .then((response) => {
           
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
  
            fileLink.href = fileURL;
            fileLink.setAttribute("download", file_name);
            document.body.appendChild(fileLink);
            fileLink.click();
            this.fade(false);
          });
      },
   
      createData() {
        this.$modal.show('createBillingCmlMasterLocations')
      },
   
      detailData(index, row) {
        this.forms.idLocCategory    = row.idLocCategory
        this.forms.warehouseId      = row.warehouseId
        this.forms.locationCategory = row.locationCategory
        this.forms.zona             = row.zona
        this.forms.adddate          = row.adddate
        this.forms.addwho           = row.addwho
        this.forms.editdate         = row.editdate
        this.forms.editwho          = row.editwho
        this.$modal.show('detailBillingCmlMasterLocations')
      },
  
      editData(index, row) {
        this.forms.idLocCategory    = row.idLocCategory
        this.forms.warehouseId      = row.warehouseId
        this.forms.locationCategory = row.locationCategory
        this.forms.zona             = row.zona
        this.forms.adddate          = row.adddate
        this.forms.addwho           = row.addwho
        this.forms.editdate         = row.editdate
        this.forms.editwho          = row.editwho
        this.$modal.show('editBillingCmlMasterLocations')
      },
  
      deleteData(index, row, status) {
        this.$swal({
          title: this.$t("areYouSure"),
          text: this.$t("yourDataDelete"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.value) {
            var formData = {
              status: status,
            };
            const baseURI =
              this.$settings.endPointBilling + "dashboard/cml-billing/location-category/delete/" + row.idLocCategory;
            this.$http
              .delete(baseURI, formData,{ timeout: 60000 })
              .then((response) => {
                this.loading();
                if (response.data.status === 200) {
                  this.loadItems();
                  this.success(response.data.datas.messages);
                } else {
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
                }
              }).catch((error) => {
                this.loading();
                
       
       
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

              });
          }else{
            this.isLoading = false;
          }
        });
      },
  
      // load items is what brings back the rows from server
      loadItems() {
        const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/location-category";
        this.isLoading = true;
        //var columnFilters = this.serverParams.columnFilters;
  
  
        return this.$http
          .get(
             baseURI +
             `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&warehouseId=${this.serverParams.columnFilters.warehouseId}&locationCategory=${this.serverParams.columnFilters.locationCategory}&zona=${this.serverParams.columnFilters.zona}&idLocCategory=${this.serverParams.columnFilters.idLocCategory}`,
            { timeout: 60000 })
          .then((response) => {
            this.isLoading = false;
            this.rows = response.data.datas.data;
            this.totalRecords = response.data.datas.total;
          }).catch((error) => {
                this.loading();
                
       
       
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

              });
      },
  
      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
        this.loadItems();
      },
  
      onColumnFilter(params) {
        this.updateParams(params);
      },
  
      onPageChange(params) {
        this.updateParams({ page: params.currentPage });
      },
  
      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params[0].type,
            field: params[0].field,
          },
        });
      },
  
      onPerPageChange(params) {
        this.updateParams({ per_page: params.currentPerPage });
      },
  
      resultError(data) {
        var count = Object.keys(data).length;
        for (var x = 0; x < count; x++) {
          var nameOb = Object.keys(data)[x];
          var objectData = data[nameOb];
          for (var y = 0; y < objectData.length; y++) {
            this.error(objectData[y]);
          }
        }
      },
  
      success(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "success",
          title: kata,
        });
      },
  
      error(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "error",
          title: kata,
        });
      },
  
      fade(sType) {
        this.isLoading = sType;
      },
  
      loading() {
        this.fade(true);
        setTimeout(() => {
          this.isLoading = false;
        }, 1000); // hide the message after 3 seconds
      },
  
      fetchIt() {
        const userDatas     = this.$getUserInfo();
        this.detailUser     = userDatas.sub;
        // this.permision_role = userDatas.sub.permision_role;
        let rolePermision = [];
        userDatas.sub.permision_role.forEach(function(permision){
          if(permision.permission.controller == 'MasterLocationCmlController'){
            rolePermision = permision;
            // console.log(permision);
          }
        });
  
        if(!rolePermision.method_read){
          this.$router.push("/authorized-error");
        }
        this.permision_role = rolePermision;
  
      },
   
    },
    events: {},
    created: function () {},
    mounted() {
      this.fetchIt();
      this.loading();
    },
  };
  </script>
  <style scoped>
  </style>